"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBatchFrozen = exports.IBatchInactive = exports.IBatchStatus = void 0;
var IBatchStatus;
(function (IBatchStatus) {
    IBatchStatus["OPEN__THIS_BATCH_CAN_ACCEPT_MORE_TRANSACTIONS_OPEN"] = "open";
    IBatchStatus["CLOSED__THIS_BATCH_IS_CLOSED_TO_NEW_TRANSACTIONS_AND_IS_READY_TO_BE_SENT_TO_THE_PROCESSOR_CLOSED"] = "closed";
})(IBatchStatus = exports.IBatchStatus || (exports.IBatchStatus = {}));
var IBatchInactive;
(function (IBatchInactive) {
    IBatchInactive[IBatchInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IBatchInactive[IBatchInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IBatchInactive = exports.IBatchInactive || (exports.IBatchInactive = {}));
var IBatchFrozen;
(function (IBatchFrozen) {
    IBatchFrozen[IBatchFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IBatchFrozen[IBatchFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IBatchFrozen = exports.IBatchFrozen || (exports.IBatchFrozen = {}));
